import { useState } from "react";
import styled from "@emotion/styled";
import { Text } from "styles/utility-components";

import { DropdownMenu, DropdownMenuTrigger } from "components/ui/dropdown_menu";
import { createUseDebounce } from "lib/debounce";
import type { StotlesBlockNoteEditor } from "../types";
import { useStotlesBlockNoteEditor } from "../useStotlesBlockNoteEditor";
import { getWordAndCharacterCount } from "../utils";

type CountType = "words" | "characters";

const COUNT_TYPES: CountType[] = ["words", "characters"];

export default function WordCountButton() {
  const editor = useStotlesBlockNoteEditor();
  const [counts, setCounts] = useState(getWordAndCharacterCount(editor.document));
  const [selectedCountType, setSelectedCountType] = useState<CountType>("words");

  const useDebounce = createUseDebounce(500);
  const debouncedOnEditorChanged = useDebounce((ed: StotlesBlockNoteEditor) => {
    setCounts(getWordAndCharacterCount(ed.document));
  });

  editor.onChange(debouncedOnEditorChanged);

  return (
    <DropdownMenu
      width="fit-content"
      trigger={
        <DropdownMenuTrigger buttonType="primary" buttonStyle="inverse">
          {counts[selectedCountType]} {selectedCountType}
        </DropdownMenuTrigger>
      }
    >
      {COUNT_TYPES.filter((countType) => countType !== selectedCountType).map((type) => (
        <MenuItem key={type} onClick={() => setSelectedCountType(type)}>
          {counts[type]} {type}
        </MenuItem>
      ))}
    </DropdownMenu>
  );
}

const MenuItem = styled(Text)({
  padding: "4px 12px",
  cursor: "pointer",
});
